import { UserDto } from '@fms-run/backend-api-lib';
import { useQuery } from '@tanstack/react-query';

import { getCurrentUser } from '../../services/users.service';

export const userKeys = {
  all: ['users'] as const,
  current: () => [...userKeys.all, 'current'] as const,
};

/**
 * Hook to fetch current authenticated user
 */
export function useCurrentUser(enabled: boolean = true) {
  return useQuery<UserDto, Error>({
    enabled,
    queryFn: getCurrentUser,
    queryKey: userKeys.current(),
    // 5 minutes
    retry: (failureCount, error: any) => {
      // Don't retry on authentication errors
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return false;
      }

      return failureCount < 3;
    },
    staleTime: 5 * 60 * 1000,
  });
}
